import { IServerResponse } from './../../../global/interfaces/server_response';
import { ErrorsDict, IFormErrorService } from './../../../global/services/form_error_service/form_error_service';
import { IDelegateController, IDelegateResponder, IDelegateConstant } from 'ui-ng-delegate';
import { ICommand } from 'core-ts-types';
import { Exam } from './../../builders/exam_builder';

export class TransferExamTileController {
  public validations: {
    exam_score: RegExp;
  };
  private exam: Exam;
  private minScore: number;
  private maxScore: number;
  private examTypeTitle: string;
  private scoreHelpText: string;
  private isLast: boolean;
  private errors: ErrorsDict;
  constructor(
    private deselectTransferExamCommand: ICommand,
    private $scope: any,
    private formErrorService: IFormErrorService,
    private examScoreRegex: RegExp,
    private $timeout: ng.ITimeoutService
  ) {
    $scope.onExitTab = () => {
      this.errors = {};
      this.deselectTransferExamCommand($scope.exam).catch((res: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.errors = this.formErrorService(res.data!.error);
      });
    };
    this.validations = {
      exam_score: this.examScoreRegex
    };
  }

  updateScore($event: any) {
    const timeToReflectChanges = 300;
    this.$timeout(() => {
      if ($event.target.invalid) {
        return;
      }
      this.$scope.onChange({ exam: this.exam });
    }, timeToReflectChanges);
  }

  $onInit() {
    this.exam = this.$scope.exam;
    this.minScore = this.$scope.minScore;
    this.maxScore = this.$scope.maxScore;
    this.examTypeTitle = this.$scope.examTypeTitle;
    this.scoreHelpText = this.$scope.scoreHelpText;
    this.isLast = !!this.$scope.isLast;
  }
}

class TransferExamTileDelegate {
  constructor(DelegateController: IDelegateController, transferExamTileDelegateConfiguration: IDelegateConstant) {
    DelegateController(this, transferExamTileDelegateConfiguration);
  }
}

angular
  .module('capability-ng-transfer')
  .service('transferExamTileDelegate', TransferExamTileDelegate)
  .constant('transferExamTileDelegateConfiguration', {
    uniqueComponent: 'transfer-exam-tile',
    vocabulary: {
      strobe: function(scope: ng.IScope, el: JQuery) {
        el.children('.tile').addClass('transfer-exam-tile--strobe');
      }
    }
  })
  .controller('ngTransferExamTileController', TransferExamTileController)
  .directive('transferExamTile', function(
    DelegateResponder: IDelegateResponder,
    transferExamTileDelegateConfiguration: IDelegateConstant
  ): ng.IDirective {
    return {
      controller: 'ngTransferExamTileController',
      templateUrl: 'lib/transfer/components/exam_tile/exam_tile.html',
      controllerAs: '$ctrl',
      scope: {
        exam: '<',
        minScore: '@',
        maxScore: '@',
        examTypeTitle: '@',
        scoreHelpText: '@',
        onChange: '&',
        isLast: '<?'
      },
      link: DelegateResponder(transferExamTileDelegateConfiguration, function(scope, elements, attrs) {})
    };
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/exam_tile/exam_tile.ts